import { render, staticRenderFns } from "./StatBox.vue?vue&type=template&id=69488902&scoped=true&"
import script from "./StatBox.vue?vue&type=script&lang=js&"
export * from "./StatBox.vue?vue&type=script&lang=js&"
import style0 from "./StatBox.vue?vue&type=style&index=0&id=69488902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69488902",
  null
  
)

export default component.exports